/** NFD, sem marcas diacríticas, minúsculas, `'`/`’` removidos, espaços colapsados (igual à da API, spec 10 §5.2). */
export function nomeSemAcento(nome: string): string {
  return nome
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
